<template>
  <v-form ref="form" autocomplete="off" @submit.prevent="save">
    <v-row>

      <v-col cols="12" sm="6">
        <v-text-field

            prepend-icon="title"
            name="name"
            v-model="form.name"
            :label="$t('delivery.productCategory.labels.name')"
            :placeholder="$t('delivery.productCategory.labels.name')"
            :error="hasInputErrors('name')"
            :error-messages="getInputErrors('name')"
            color="secondary"
            :rules="required"
        ></v-text-field>
      </v-col>

      <v-col cols="12" sm="6">
        <v-text-field

            prepend-icon="short_text"
            name="name"
            v-model="form.printName"
            :label="$t('delivery.productCategory.labels.printName')"
            :placeholder="$t('delivery.productCategory.labels.printName')"
            :error="hasInputErrors('printName')"
            :error-messages="getInputErrors('printName')"
            color="secondary"
            :rules="required"
        ></v-text-field>
      </v-col>

      <v-col cols="12" sm="6">
        <color-input
            v-model="form.backgroundColor"
            :label="$t('delivery.productCategory.labels.backgroundColor')"
            :placeholder="$t('delivery.productCategory.labels.backgroundColor')"
            color="secondary"
        ></color-input>
      </v-col>


      <v-col cols="12" sm="6">
        <color-input
            v-model="form.borderColor"
            :label="$t('delivery.productCategory.labels.borderColor')"
            :placeholder="$t('delivery.productCategory.labels.borderColor')"
            color="secondary"
        ></color-input>
      </v-col>

      <v-col cols="12" sm="6">
        <color-input
            v-model="form.fontColor"
            :label="$t('delivery.productCategory.labels.fontColor')"
            :placeholder="$t('delivery.productCategory.labels.fontColor')"
            color="secondary"
        ></color-input>
      </v-col>


      <v-col cols="12" sm="6">
        <google-material-icon-combobox v-model="form.icon"></google-material-icon-combobox>
      </v-col>

      <v-col cols="12" sm="6">
        <color-input
            v-model="form.iconColor"
            :label="$t('delivery.productCategory.labels.iconColor')"
            :placeholder="$t('delivery.productCategory.labels.iconColor')"
            color="secondary"
        ></color-input>
      </v-col>


      <v-col cols="12" sm="6">
        <v-text-field

            prepend-icon="price_change"
            name="surcharge"
            v-model.number="form.surcharge"
            type="number"
            :label="$t('delivery.productCategory.labels.surcharge')"
            :placeholder="$t('delivery.productCategory.labels.surcharge')"
            :error="hasInputErrors('surcharge')"
            :error-messages="getInputErrors('surcharge')"
            color="secondary"

        ></v-text-field>
      </v-col>



      <v-col cols="12" sm="6">
        <v-text-field
            prepend-icon="delivery_dining"
            name="minimumDeliveryQuantity"
            v-model.number="form.minimumDeliveryQuantity"
            type="number"
            :label="$t('delivery.productCategory.labels.minimumDeliveryQuantity')"
            :placeholder="$t('delivery.productCategory.labels.minimumDeliveryQuantity')"
            color="secondary"
        ></v-text-field>
      </v-col>

      <v-col cols="12" sm="6">
        <v-text-field
            prepend-icon="table_bar"
            name="minimumTakeAwayQuantity"
            v-model.number="form.minimumTakeAwayQuantity"
            type="number"
            :label="$t('delivery.productCategory.labels.minimumTakeAwayQuantity')"
            :placeholder="$t('delivery.productCategory.labels.minimumTakeAwayQuantity')"
            color="secondary"
        ></v-text-field>
      </v-col>

      <v-col cols="12" sm="6">
        <v-checkbox
            prepend-icon="home"
            name="homeGallery"
            v-model="form.homeGallery"
            :label="$t('delivery.product.labels.homeGallery')"
            :error="hasInputErrors('homeGallery')"
            :error-messages="getInputErrors('homeGallery')"
            color="secondary"
        ></v-checkbox>
      </v-col>

      <v-col cols="12" sm="6">
        <v-checkbox
            prepend-icon="flash_on"
            name="immediateDelivery"
            v-model="form.immediateDelivery"
            :label="$t('delivery.productCategory.labels.immediateDelivery')"
            :error="hasInputErrors('immediateDelivery')"
            :error-messages="getInputErrors('immediateDelivery')"
            color="secondary"
        ></v-checkbox>
      </v-col>

      <v-col cols="12" sm="6">
        <v-checkbox
            prepend-icon="local_bar"
            name="drink"
            v-model="form.drink"
            :label="$t('delivery.productCategory.labels.drink')"
            :error="hasInputErrors('drink')"
            :error-messages="getInputErrors('drink')"
            color="secondary"
        ></v-checkbox>
      </v-col>

      <v-col cols="12" sm="6">
        <v-checkbox
            v-model="form.dozen"
            prepend-icon="inventory_2"
            name="dozen"
            :label="$t('delivery.productCategory.labels.dozen')"
            color="secondary"
        ></v-checkbox>
      </v-col>

      <v-col cols="12" sm="6">
        <v-checkbox
            prepend-icon="toggle_on"
            name="active"
            v-model="form.active"
            :label="$t('delivery.productCategory.labels.active')"
            :error="hasInputErrors('active')"
            :error-messages="getInputErrors('active')"
            color="secondary"
        ></v-checkbox>
      </v-col>

    </v-row>
  </v-form>
</template>

<script>

import {InputErrorsByProps, RequiredRule, ColorInput} from '@dracul/common-frontend'
import GoogleMaterialIconCombobox
  from "@/modules/base/components/GoogleMaterialIconCombobox/GoogleMaterialIconCombobox";


export default {
  name: "ProductCategoryForm",
  mixins: [InputErrorsByProps, RequiredRule],
  components: {GoogleMaterialIconCombobox, ColorInput},
  props: {
    value: {
      type: Object,
      required: true
    },
  },
  computed: {
    form: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    form: {
      handler(newVal) {
        this.$emit('input', newVal)
      },
      deep: true
    }
  },
  methods: {
    validate() {
      return this.$refs.form.validate()
    }
  }
}
</script>

<style scoped>

</style>
